import { makeAutoObservable } from "mobx";

export class CustomerStore {
  exchangeRate = 0.0;
  variance = 0.0;
  constructor() {
    makeAutoObservable(this);
  }
  getExchangeRate() {
    return this.exchangeRate;
  }
  setExchangeRete(data: any) {
    this.exchangeRate = data;
  }
}
export const customerStore = new CustomerStore();
